import * as ExercisesApi from 'api/exercises';
import { call, put, select } from 'redux-saga/effects';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators as exercisesActionCreators } from 'store/exercises';

export function* loadExercises() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	const exercises = yield call(ExercisesApi.fetchExercises);
	yield put(exercisesActionCreators.doRequestExercisesSuccess(exercises));
}
